var _a, _b;
import { createSlice } from '@reduxjs/toolkit';
import analytics from '@utils/analytics';
const locale = ((_a = document.documentElement.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'en';
const storeApp = document.querySelector('#storelocator');
const profileStoreId = (_b = storeApp === null || storeApp === void 0 ? void 0 : storeApp.dataset) === null || _b === void 0 ? void 0 : _b.storeid;
const COLLECTIONS = ['men', 'women', 'children'];
const COLLECTIONSCODES = ['01', '02', '03'];
// place the map centered based on your country on landing
// const center = {
//   lat: Number(storeApp?.dataset?.centerLat),
//   lng: Number(storeApp?.dataset?.centerLng),
// };
// TODO move currentCity/country/region inside filters?
const initialState = {
    baseUrl: window.basePath === '/' ? `${location.origin}/${locale}` : `${location.origin}${window.basePath}/${window.language}_${window.country}`,
    stores: [],
    storesInMap: undefined,
    currentStoreId: profileStoreId || undefined,
    center: undefined,
    zoom: undefined,
    currentLocation: undefined,
    bounds: undefined,
    updateBounds: undefined,
    filters: {
        services: [],
        collections: [],
    },
    address: undefined,
    metadata: undefined,
    openClusterDetail: false,
};
const storelocatorSlice = createSlice({
    name: 'storelocator',
    initialState: initialState,
    reducers: {
        updateMetadata: (state, action) => {
            state.metadata = action.payload;
        },
        updateStores: (state, action) => {
            state.stores = action.payload;
            state.storesInMap = action.payload;
        },
        updateStoresInMap: (state, action) => {
            state.storesInMap = action.payload;
        },
        setAddress: (state, action) => {
            state.address = action.payload;
        },
        setCurrentStore: (state, action) => {
            state.currentStoreId = action.payload;
        },
        toggleService: (state, action) => {
            const serviceEntry = action.payload;
            const service = state.filters.services.find((service) => service === serviceEntry);
            if (service) {
                state.filters.services = state.filters.services.filter((service) => service !== serviceEntry);
            }
            else {
                analytics.storelocatorOpenRefine(serviceEntry);
                state.filters.services = [serviceEntry, ...state.filters.services];
            }
        },
        toggleCollection: (state, action) => {
            const collectionEntry = action.payload;
            const collection = state.filters.collections.find((collection) => collection === collectionEntry);
            if (collection) {
                state.filters.collections = state.filters.collections.filter((collection) => collection !== collectionEntry);
            }
            else {
                analytics.storelocatorOpenRefine(COLLECTIONS[COLLECTIONSCODES.indexOf(collectionEntry)]);
                state.filters.collections = [collectionEntry, ...state.filters.collections];
            }
        },
        setCenter: (state, action) => {
            state.center = action.payload;
        },
        setZoom: (state, action) => {
            state.zoom = action.payload;
        },
        updateLocation: (state, action) => {
            state.currentLocation = action.payload;
        },
        setBounds: (state, action) => {
            state.bounds = action.payload;
        },
        setUpdateBounds: (state, action) => {
            state.updateBounds = action.payload;
        },
        updateLocationFromQuery: (state, action) => {
            const locationString = decodeURIComponent(action.payload || '');
            if (locationString) {
                const valueList = locationString.split(',');
                state.center = { lat: parseFloat(valueList[0]), lng: parseFloat(valueList[1]) };
                state.zoom = parseFloat(valueList[2]);
            }
        },
        updateServiceFromQuery: (state, action) => {
            const filterString = decodeURIComponent(action.payload || '');
            if (filterString) {
                const valueList = filterString.split(',');
                valueList.forEach((filter) => {
                    if (filter != '')
                        state.filters.services = [filter, ...state.filters.services];
                });
            }
        },
        updateCollectionsFromQuery: (state, action) => {
            const filterString = decodeURIComponent(action.payload || '');
            if (filterString) {
                const valueList = filterString.split(',');
                valueList.forEach((filter) => {
                    if (filter != '')
                        state.filters.collections = [filter, ...state.filters.collections];
                });
            }
        },
        setOpenClusterDetail: (state, action) => {
            state.openClusterDetail = action.payload;
        },
    },
});
export const { setAddress, setCurrentStore, toggleService, toggleCollection, setCenter, setZoom, updateLocation, setOpenClusterDetail } = storelocatorSlice.actions;
export default storelocatorSlice;
